<span class="dropdown">
    <a class="dropdown-toggle" href="javascript:void(0)" id="dropdownMenuLink" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false" data-title="opzioni">
        <span class="glyphicon glyphicon-option-vertical"></span>
    </a>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
        <ng-content></ng-content>
    </ul>
</span>